import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import { UncontrolledTooltip } from 'reactstrap';
import { useIntl } from 'react-intl';

import { searchTerm } from '../../helpers/Terms';

const UploadFileTaxonomyMultiValue = (props) => {
  const { data, showBlocked } = props;

  const intl = useIntl();

  const term = searchTerm(data.value);

  const isTermBlocked = term && term.blocked;

  if (isTermBlocked && !showBlocked) return null;

  return (
    <components.MultiValue {...props}>
      {data.label}
      {isTermBlocked && (
      <>
        <span id={`smart-collection-filters-tag-blocked-${term.id}`}>
          <i className="ml-2 fa-solid fa-octagon-xmark" />
        </span>
        <UncontrolledTooltip
          target={`smart-collection-filters-tag-blocked-${term.id}`}
        >
          {intl.formatMessage({
            defaultMessage: 'This tag is blocked',
          })}
        </UncontrolledTooltip>
      </>
      )}
    </components.MultiValue>
  );
};

UploadFileTaxonomyMultiValue.propTypes = {
  data: PropTypes.object.isRequired,
  showBlocked: PropTypes.bool.isRequired,
};

export default UploadFileTaxonomyMultiValue;
